import courseDetailsMapping from "../../utils/courseDetailsMapping";

const FilterItem = ({
  title,
  updateTerms,
  values: { items, attr },
  terms,
  className = "col-12",
  open,
}) => {
  const mapping = courseDetailsMapping();

  const getIsSelected = (attribute, item) =>
    terms[attribute] && terms[attribute].includes(item);
  if (open === "close") {
    return null;
  }

  return (
    <div className={`filter-item ${className}`}>
      <h4>{title}</h4>
      <ul className="list-unstyled d-flex flex-wrap">
        {items.map((item, index) => {
          let btnClass = "filter-item-button me-2 mb-2";
          if (getIsSelected(attr, item)) {
            btnClass += " --active";
          }

          return (
            <li key={index}>
              <button
                className={btnClass}
                onClick={(e) => {
                  e.preventDefault();
                  updateTerms(attr, item);
                }}
              >
                {mapping[item] || item}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FilterItem;
